import { render, staticRenderFns } from "./PrkAddDisciplineModal.vue?vue&type=template&id=b907ee2a&scoped=true&"
import script from "./PrkAddDisciplineModal.vue?vue&type=script&lang=js&"
export * from "./PrkAddDisciplineModal.vue?vue&type=script&lang=js&"
import style0 from "./PrkAddDisciplineModal.vue?vue&type=style&index=0&id=b907ee2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b907ee2a",
  null
  
)

export default component.exports